import {Reducer} from 'redux';

import {environment} from '../../../environments/environment';
import {
  IAddTracks,
  ICreatePlaylist,
  IFetchEvents,
  IPlaylistAdd,
  IPlaylistRemove,
  ISetEvent,
  ISetFamilies,
  ISetFamily,
  ISetRemote,
  ISetTempo,
  ISetWishlist,
  IUnsetRemote,
  TPlaylist,
  TRemote,
  TWishlist,
} from '../actions';
import {AssoMediaEvent, Playlist, Tempo} from '../entities';

export interface IPlaylistsState {
  events: {[key: string]: Playlist};
  tempos: {[key: string]: Tempo};
}
export const defaultPlaylistsState = {
  events: {},
  tempos: {},
};
const defaultIconUrl = 'assets/icons/default_icon.webp';
const getCover = (ame: AssoMediaEvent): string => ame && ame.media && ame.media.id
  ? `${environment.remoteApi}/${environment.apiVersion}/media/artwork/${ame.media.id}`
  : defaultIconUrl;

const getPlaylistDetail = ({ assoMediaEvent = [], ...item }: Playlist) => ({
  ...item,
  cover: getCover(assoMediaEvent[0]),
  assoMediaEvent,
  tracks: assoMediaEvent.length
});

export const playlistsReducer: Reducer<IPlaylistsState> = (
  state: IPlaylistsState = defaultPlaylistsState,
  action: ISetEvent | ISetRemote | IUnsetRemote | ISetTempo | ISetFamily
    | IFetchEvents | IPlaylistAdd | IPlaylistRemove | ISetFamilies | IAddTracks | ICreatePlaylist | ISetWishlist
): IPlaylistsState => {
  switch (action.type) {
    case TRemote.SET_REMOTE:
      if (state.events.length > 0 && environment.enableDesktopMode) {
        console.debug('SET_REMOTE', state, environment.enableDesktopMode);
        return state;
      }
      console.debug('SET_REMOTE', defaultPlaylistsState, environment.enableDesktopMode);
      return defaultPlaylistsState;
    case TRemote.UNSET_REMOTE:
      return defaultPlaylistsState;
    case TPlaylist.SET_EVENT:
      const events = {
        ...state.events,
        [action.payload.id]: getPlaylistDetail(action.payload)
      };
      return { ...state, events };
    case TWishlist.SET_WISHLIST:
      return { ...state, events: { ...state.events, [action.payload.id]: getPlaylistDetail(action.payload) } };
    case TPlaylist.SET_TEMPO:
      const tempos = {
        ...state.tempos,
        [action.payload.id]: getPlaylistDetail(action.payload as Playlist)
      };
      return { ...state, tempos };
    case TPlaylist.ADD_TRACKS:
      const destination = state.events[action.payload.playlistId];
      return {
        tempos: state.tempos,
        events: {
          ...state.events,
          [action.payload.playlistId]: {
            ...destination,
            assoMediaEvent: [...destination.assoMediaEvent, ...action.payload.assoMediaEvent]
          }
        }
      };
    case TPlaylist.CREATE_PLAYLIST:
      return {
        tempos: state.tempos,
        events: {
          ...state.events,
          [action.payload.id]: {
            ...action.payload,
            assoMediaEvent: [],
            wishlist: false,
          }
        }
      };
  }
  return state;
};
